import { useMutation } from "@apollo/client";
import { SetFileAsUploadedDocument } from "../../gql/generated/graphql";

interface PresignedUpload {
  uploadUrl: string;
  fields: Record<string, string>;
  fileId: string;
}

// Sends the file to S3 through the presigned POST returned by the API, then confirms it to the API
export const usePresignedFileUpload = () => {
  const [setFileAsUploaded] = useMutation(SetFileAsUploadedDocument);

  const uploadFile = async (
    { uploadUrl, fields, fileId }: PresignedUpload,
    file: File
  ) => {
    const formData = new FormData();
    Object.entries(fields).forEach(([key, value]) => {
      formData.append(key, value);
    });

    formData.append("file", file);

    const uploadRes = await fetch(uploadUrl, {
      method: "POST",
      body: formData,
    });

    if (!uploadRes.ok) {
      throw new Error(`Failed to upload file with status ${uploadRes.status}`);
    }

    const res = await setFileAsUploaded({ variables: { id: fileId } });

    if (!res.data?.setFileAsUploaded) {
      throw new Error("Error confirming file upload");
    }
  };

  return { uploadFile };
};
